/** Fonts available in the editor dropdown. */
export const EDITOR_FONTS = [
  'Abril Fatface',
  'Albert Sans',
  'Anton',
  'Archivo',
  'Arial',
  'Arimo',
  'Arvo',
  'Asap',
  'Barlow',
  'Bebas Neue',
  'Bitter',
  'Bricolage Grotesque',
  'Bungee',
  'Cabin',
  'Catamaran',
  'Caveat',
  'Comfortaa',
  'Cormorant Garamond',
  'Crimson Text',
  'Dancing Script',
  'DM Sans',
  'EB Garamond',
  'Exo 2',
  'Figtree',
  'Fira Sans',
  'Fraunces',
  'Fredoka',
  'Geologica',
  'Georgia',
  'Great Vibes',
  'Hind',
  'Instrument Sans',
  'Inter',
  'Josefin Sans',
  'Josefin Slab',
  'Karla',
  'Lato',
  'Lexend',
  'Libre Baskerville',
  'Literata',
  'Lobster',
  'Lora',
  'Manrope',
  'Maven Pro',
  'Merriweather',
  'Montserrat',
  'Mukta',
  'Newsreader',
  'Noto Sans',
  'Nunito',
  'Onest',
  'Open Sans',
  'Oswald',
  'Outfit',
  'Pacifico',
  'PT Sans',
  'Permanent Marker',
  'Playfair Display',
  'Plus Jakarta Sans',
  'Poppins',
  'Quicksand',
  'Rajdhani',
  'Raleway',
  'Righteous',
  'Roboto',
  'Rubik',
  'Schibsted Grotesk',
  'Signika',
  'Sora',
  'Source Sans Pro',
  'Space Grotesk',
  'Syne',
  'Teko',
  'Times New Roman',
  'Titillium Web',
  'Ubuntu',
  'Varela Round',
  'Work Sans',
  'Yanone Kaffeesatz',
];
